<template>
    <van-form @failed="onFailed" @submit="handleSubmit" :show-error="false">
        <van-row class="non-bottom"></van-row>
        <van-field v-model="producer.producerCode" label="生产商编码" placeholder="请输入3-8位数字、字母组合的生产商编码" maxlength="20" autosize
                 clearable :rules="rules.producerCodeRule"
                 input-align="right" error-message-align="right" label-width="auto"
                 class="van-field-border van-field-required"></van-field>

        <van-popover v-model="showPopover" position="bottom" @open="popoverOpen">
            <template #reference>
                <van-field v-model="producer.nameChinese" label="名称(中)" placeholder="请输入生产商中文名称" clearable
                           maxlength="100" :rules="rules.nameChineseRule" @input="handleInput" input-align="right"
                           error-message-align="right" label-width="auto"
                           class="van-field-border van-field-required"/>
              <div></div>
            </template>
            <div v-for="(item,index) in enterpriseList" :key="index" class="hs-code" @click="handleClick(item)">
                {{ item.enterpriseName }}
            </div>
        </van-popover>

        <van-field v-model="producer.nameEnglish" label="名称(英)" placeholder="请输入生产商英文名称" type="textarea" rows="1"
                   autosize clearable :rules="rules.nameEnglishRule" error-message-align="right"
                   input-align="right" class="van-field-border van-field-required"></van-field>

        <van-field v-model="producer.addressChinese" label="地址(中)" placeholder="请输入生产商中文地址" type="textarea" rows="1"
                 autosize clearable
                 input-align="right" error-message-align="right"
                 :rules="rules.addressChineseRule" class="van-field-border van-field-required"></van-field>

        <van-field v-model="producer.addressEnglish" label="地址(英)" placeholder="请输入生产商英文地址" type="textarea" rows="1"
                   autosize clearable :rules="rules.addressEnglishRule" error-message-align="right"
                   input-align="right" class="van-field-border van-field-required"></van-field>

        <van-field v-model="producer.unifiedSocialCreditCode" label="统一社会信用代码" placeholder="请输入18位统一社会信用代码" maxlength="20" autosize
                 clearable :rules="rules.unifiedSocialCreditCodeRule"
                 input-align="right" error-message-align="right" label-width="auto"
                 class="van-field-border"></van-field>

        <van-field v-model="producer.contact" label="联系人" placeholder="请输入联系人称呼" type="textarea" rows="1" autosize
                   clearable
                   input-align="right" class="van-field-border"></van-field>

        <van-field v-model="producer.contactModel" label="联系方式" placeholder="请输入联系方式" type="textarea" rows="1" autosize
                   clearable
                   input-align="right" class="van-field-border"></van-field>

        <van-row class="non-bottom"></van-row>

        <van-row class="result-footer">
            <van-button round block type="info" native-type="submit">保存</van-button>
        </van-row>

    </van-form>


</template>

<script>
    import {noticeManager} from "@zhoujianhui/vip-core";
    import ProducerCreationDto from "../dto/ProducerCreationDto";
    import producerService from "../service/producer-service";
    import filingService from "../../product-filing/service/filing-service";


    export default {
        name: "producerAdd",
        data() {
            return {
                producer: new ProducerCreationDto(),
                rules: ProducerCreationDto.getRules(),

                submitDataError: null,
                showPopover: false,
                enterpriseList: []
            }
        },
        methods: {
            handleInput(val) {
                if (val.length > 3) {
                    this.getEnterprise();
                } else {
                    this.enterpriseList = [];
                }
            },
            async getEnterprise() {
                let enterpriseQuery = {};
                enterpriseQuery.key = this.producer.nameChinese;
                const result = await filingService.getEnterprise(enterpriseQuery);
                if (result.isSuccess()) {
                    this.enterpriseList = result.data;
                    this.showPopover = true;
                } else {
                    noticeManager.showMessage(result.msg, result.type);
                }
            },
            popoverOpen() {
                this.$nextTick(() => {
                    let popover = document.getElementsByClassName('van-popover')[0];
                    let box = document.getElementsByClassName('query-box')[0];
                    popover.style.width = box.clientWidth + 'px';
                })
            },
            handleClick(item) {
                this.producer.producerCode = item.socialCreditCode;
                this.producer.nameChinese = item.enterpriseName;
                this.showPopover = false;
            },

            onFailed(error) {
                this.submitDataError = error;
            },
            async handleSubmit() {
                const result = await producerService.addProducer(this.producer);
                if (result.isSuccess()){
                    await this.$router.go(-1);
                }
                noticeManager.showMessage(result.msg, result.type);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "src/origin-certificate/style/form-add";

    /*弹出框样式*/
    .van-popover__wrapper {
        width: 100%;
    }
</style>

